import { Check, Eye } from "phosphor-react";
import React from "react";
import useNavigation from "~/admin/hooks/useNavigation";
import Badge from "~/admin/components/Badge";
import Card from "~/admin/components/Card";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import Pagination from "~/admin/components/Pagination";
import moment from "moment";

export default function ReportsListTab({ reportedUsers, onPaginate }) {
  const { navigate } = useNavigation();

  return (
    <>
      {reportedUsers.items?.length > 0 ? (
        <Card>
          <Table>
            <thead>
              <Tr>
                <Th>Nom</Th>
                <Th>Nombre de report</Th>
                <Th>Dernier report</Th>
                <Th>Type</Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {reportedUsers.items.map((reportedUser) => {
                return (
                  <Tr key={reportedUser.id}>
                    <Td>{reportedUser.name}</Td>
                    <Td className="text-danger">{reportedUser.nbReports}</Td>
                    <Td>
                      {moment(reportedUser.lastReport).format("DD/MM/YYYY")}
                    </Td>
                    <Td>
                      {reportedUser.type === "influencer" ? (
                        <Badge color="light">Influenceur</Badge>
                      ) : (
                        <Badge color="info">Entreprise</Badge>
                      )}
                    </Td>
                    <Td>
                      <Eye
                        className="cursor-pointer hover:text-gray-400"
                        size={24}
                        onClick={() => navigate(`reports/${reportedUser.id}`)}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          {reportedUsers.items && (
            <div className="pt-4 text-center">
              <Pagination
                lastPage={reportedUsers.lastPage}
                currentPage={reportedUsers.currentPage}
                onPaginate={onPaginate}
              />
            </div>
          )}
        </Card>
      ) : (
        <div className="px-4 py-2 bg-green-300 text-green-700 w-fit rounded-md mx-auto flex space-x-4 items-center">
          <div className="rounded-full border w-fit border-green-700 h-fit">
            <Check />
          </div>
          <div>Il n'y a aucun signalement !</div>
        </div>
      )}
    </>
  );
}
